import { useState } from "react"
import { TFilters } from "../../../../../components/TableDataGridV2/types"
import { Box, Button, Container, Divider, Grid, TextField } from "@mui/material"
import DateComIntervalo from "../../../../../components/DateComIntervalo"
import { permitirApenasNumeros } from "../../../../../helpers/masks"
import SelectFuncoes from "../../../../../components/SelectsSimpleApiQuery/SelectFuncao"
import SelectPublico from "../../../../../components/SelectsSimpleApiQuery/SelectPublico"
import moment from "moment"
import SelectSituacoesFinanceiras from "../../../../../components/SelectSituacoesFinanceiras"
import { quebrarIdTituloString } from "../../../../../helpers/verificadores"
import SelectDepartamentoFinanceiro from "../../../../../components/SelectsSimpleApiQuery/SelectDepartamentoFinanceiro"

export default function PreFiltros({
    filtros,
    isListarTodas = false,
    onSubmitFilters
}: PreFiltrosProps) {

    const [internFilters, setInternFilters] = useState(filtros)

    const filtrarObj = (obj: TFilters) => {
        const novoObjeto: TFilters = { ...obj };

        Object.keys(novoObjeto).forEach((key) => {
            if (key.startsWith('publico_dado')) {
                novoObjeto.tipo_publico_contem = [novoObjeto[key].tipo_publico];
                novoObjeto.codigo_publico_contem = [novoObjeto[key].codigo_publico];
                delete novoObjeto[key];
            }

            if (key.startsWith('situacoes')) {
                if (novoObjeto[key] === "Em aberto") {
                    novoObjeto.saldo_principal_maior_igual = 1
                    novoObjeto.data_recebimento_is_null = true
                }
                if (novoObjeto[key] === "Baixados") {
                    novoObjeto.saldo_principal_menor_igual = 0
                    novoObjeto.data_recebimento_is_not_null = true
                }
                if (novoObjeto[key] === "Em atraso") {
                    novoObjeto.saldo_principal_maior_igual = 1
                    novoObjeto.data_recebimento_is_null = true
                    novoObjeto.data_vencimento_fim = moment()
                }
                if (novoObjeto[key] === "Vencendo hoje") {
                    novoObjeto.data_vencimento_inicio = moment()
                    novoObjeto.data_vencimento_fim = moment()
                    novoObjeto.saldo_principal_maior_igual = 1
                    novoObjeto.data_recebimento_is_null = true
                }
                delete novoObjeto[key];
            }
        });

        return novoObjeto;
    };

    const handleInsertFiltros = (prop: string, value: any) => {
        if (prop === 'situacoes') {
            if (value === "Todos") {
                value = [];
            }
        }
        setInternFilters(prevState => ({ ...prevState, [prop]: value }))
    }

    const handleSubmit = () => {
        const formatValue = filtrarObj(internFilters)
        onSubmitFilters(formatValue)
    }

    return (
        <Container maxWidth="md" sx={{pb: 2}}>
            <Grid container spacing={2} sx={{ py: !isListarTodas? 2 : 0 }}>
                <Grid size={{xs: 12, md: 6}}>
                    <SelectPublico
                        value={internFilters.publico_dado}
                        onChange={(valor) => handleInsertFiltros("publico_dado", valor)}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <DateComIntervalo
                        data={{
                            inicial: internFilters.data_vencimento_inicio,
                            final: internFilters.data_vencimento_fim
                        }}
                        onChangeData={(data) => {
                            handleInsertFiltros("data_vencimento_inicio", data.inicial)
                            handleInsertFiltros("data_vencimento_fim", data.final)
                        }}
                        datePickerView={['year', 'month', 'day']}
                        formatString="DD/MM/YYYY"
                        labelInput="Data de vencimento"
                    />
                </Grid>
            </Grid>

            {!isListarTodas && <Divider />
            }
            <Grid container spacing={2} sx={{ py: 2 }}>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Código do documento"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => {
                            const { tipo, num, seq } = quebrarIdTituloString(e.target.value)
                            handleInsertFiltros("tipo_documento_pesquisar", tipo)
                            handleInsertFiltros("numero_documento_pesquisar", num)
                            handleInsertFiltros("sequencia_documento_pesquisar", seq)
                        }}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Nº da Nota fiscal"
                        variant="outlined"
                        fullWidth
                        value={internFilters.numero_nf_maior_igual}
                        onChange={(e) => {
                            handleInsertFiltros("numero_nf_pesquisar", permitirApenasNumeros(e.target.value))
                        }}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <DateComIntervalo
                        data={{
                            inicial: internFilters.data_emissao_inicio,
                            final: internFilters.data_emissao_fim
                        }}
                        onChangeData={(data) => {
                            handleInsertFiltros("data_emissao_inicio", data.inicial)
                            handleInsertFiltros("data_emissao_fim", data.final)
                        }}
                        datePickerView={['year', 'month', 'day']}
                        formatString="DD/MM/YYYY"
                        labelInput="Data de emissão"
                    />
                </Grid>

                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Valor"
                        variant="outlined"
                        fullWidth
                        type="number"
                        value={internFilters.valor_receber_maior_igual}
                        onChange={(e) => {
                            handleInsertFiltros("valor_receber_maior_igual", e.target.value)
                            handleInsertFiltros("valor_receber_menor_igual", e.target.value)
                        }}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 4}}>
                    <SelectFuncoes
                        value={internFilters.funcao_contem}
                        onChange={(value) => handleInsertFiltros("funcao_contem", value)}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 4}}>
                    <SelectDepartamentoFinanceiro
                        value={internFilters.departamento_contem}
                        onChange={(value) => handleInsertFiltros("departamento_contem", value)}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 4}}>
                    <SelectSituacoesFinanceiras
                        value={internFilters.situacoes}
                        onChange={(value) => handleInsertFiltros("situacoes", value)}
                    />
                </Grid>
            </Grid>

            <Box>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Pesquisar
                </Button>
            </Box>
        </Container>
    )
}

interface PreFiltrosProps {
    filtros: TFilters,
    isListarTodas?: boolean
    onSubmitFilters: (args: TFilters) => void
}